import { formMessage } from "./messages";

export const loginFormValidations = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("username" in fieldValues) {
    temp.username = fieldValues.username ? "" : formMessage.user_req;
  }
  if ("password" in fieldValues) {
    temp.password = fieldValues.password ? "" : formMessage.pass_req;
  }

  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};

export const registrationValidations = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("first_name" in fieldValues) {
    temp.first_name = fieldValues.first_name ? "" : formMessage.firstname;
  }
  if ("last_name" in fieldValues) {
    temp.last_name = fieldValues.last_name ? "" : formMessage.lastname;
  }
  if ("email" in fieldValues) {
    temp.email = fieldValues.email ? "" : formMessage.email;
  }
  if ("course" in fieldValues) {
    temp.course =
      Array.isArray(fieldValues.course) && fieldValues.course.length > 0
        ? ""
        : formMessage.course;
  }

  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};
